<template>
  <div id="app">
    <!-- <v-head></v-head> -->
    <router-view v-if="isReload" />
    <!-- <message /> -->
    <!-- <foot-box></foot-box> -->
  </div>
</template>

<script>
// import vHead from './components/top-header.vue'
// import FootBox from './components/foot-box.vue';
// import Message from './components/Message.vue'
// import DevicePixelRatio from './libs/rem';
import { mapActions } from "vuex";

export default {
  components: {
    // Message,
    // FootBox,
    // vHead,
  },
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isReload: true,
    };
  },
  // 禁止web端屏幕缩放
  // created() {
  // 	new DevicePixelRatio().init();//自适应屏幕的分辨率 不会因为缩放尔改变
  // 	window.addEventListener("mousewheel",function (event) {if (event.ctrlKey === true || event.metaKey) {event.preventDefault();}},{ passive: false })
  // },
  created() {
    this.fetchLanguageList(); // 在根组件加载语言翻译列表
  },
  mounted() {
    if (this.isMobile()) {
      const url = new URL("/mobile/index.html", window.location.origin);
      window.location.href = url.href;
      //   window.location.href = "https://compute.jasolar.com/mobile/index.html";
    }
  },
  methods: {
    ...mapActions("language", ["fetchLanguageList"]),
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    reload() {
      this.isReload = false;
      this.$nextTick(() => {
        this.isReload = true;
      });
    },
  },
};
</script>
<style lang="less">
@import "./assets/css/reset.css";
@import "./assets/css/style.less";
@import "./assets/css/index.css";
</style>
